import courseApi from '@/api/course'

const course = {
  namespaced: true,
  state: {
    ownedCourses: [],
    joinedCourses: [],
    fsURLs: {}
  },
  mutations: {
    SET_COURSES: (state, [oCourses, jCourses]) => {
      state.ownedCourses = oCourses || []
      state.joinedCourses = jCourses || []
    },
    SET_COURSE_FS_URL: (state, { courseId, urls }) => {
      state.fsURLs[courseId] = urls
    }
  },
  actions: {
    async getFsUrl({ state, dispatch }, courseId) {
      if (!state.fsURLs[courseId]) {
        await dispatch('fetchCourse', courseId)
      }
      return state.fsURLs[courseId]?.[0]?.value || ''
    },
    async fetchCourses({ commit }) {
      const resData = await courseApi.getCourses()

      if (resData.code === 0) {
        commit('SET_COURSES', [resData.owned, resData.joined])
      }
    },
    async fetchCourse({ commit }, courseId) {
      const res = await courseApi.getCourse(
        { id: courseId },
        { errMsg: '获取课程详情失败' }
      )

      const { stat } = res

      commit('SET_COURSE_FS_URL', {
        courseId,
        urls: stat.services?.[9]?.accessableServices || []
      })

      return res
    }
  }
}

export default course
